import React 			from 'react'
import classnames 		from 'classnames'
import {
	isFinite
} from 'lodash'

export default (props) => {
	const {
		type,
		children
	} = props

	return <div className={ classnames('pageArticle-content', {
			[`pageArticle-content--t-${ type }`]: type
		}) }>
		<SectionCols
			{ ...props }
			>
			{ children }
		</SectionCols>
	</div>
}

export const SectionCols = (props) => {
	const {
		indent,
		colWidth,
		children,
		className
	} = props

	const hasColWidth = isFinite(colWidth)

	return <div className="cols">
		{ indent ? <div className="col col--1-9 col--empty" /> : null }
		<div className={ classnames('col', {
				'col--7-9': !hasColWidth && indent,
				'col--1-1': !hasColWidth && !indent,
				[`col--${ colWidth }-9`]: hasColWidth
			}) }>
			{ children }
		</div>
	</div>
}